// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__2prki","modal":"modal_modal__2U-Wo"};